export default __webpack_public_path__ + "static/media/download.4bea7bda.jpeg";